export default __webpack_public_path__ + "static/media/screener_etoro.25e8a761.png";